export const BR_VISIT = 'visit';
export const BR_NEW_TRANSFER_BUTTON_CLICKED = 'new-transfer-button-clicked';
export const BR_ANTIFRAUD_PROTECTION_ERROR = 'antifraud_protection_error';

// Repeat transfer
export const BR_TRANSFER_REPEAT_START = 'transfer-repeat-start';

// New transfer
export const BR_NEW_TRANSFER_START = 'new-transfer-start';
export const BR_SEND_SUCCESS = 'send-success';
export const BR_TEMP_UNAVAILABLE_PROV_SELECTED = 'temporarily_unavailable_provider_selected';
export const BR_SEND_COUNTRY_TO_SELECTED = 'send_country_to_selected';
export const BR_REG_SEND_COUNTRY_TO_SELECTED = 'reg_send_country_to_selected ';

// Referral
export const BR_REFERRAL_SCREEN_PRESS_ADD = 'ref-screen-press-add';

//STRAPI Banner
export const BR_BANNER_EXTRA_BONUS_CLOSED = 'banner_extra_bonus_closed';
export const BR_BANNER_EXTRA_BONUS_PRESSED_T_AND_C = 'banner_extra_bonus_pressed_t&c';
export const BR_BANNER_EXTRA_BONUS_PRESSED_ARROW = 'banner_extra_bonus_pressed_arrow';

//System
export const BR_SYSTEM_GA_DOWN_RETRY = 'system_ga_down_retry';

export const BRAZE_EVENTS = {
    BR_VISIT,
    BR_NEW_TRANSFER_BUTTON_CLICKED,
    BR_ANTIFRAUD_PROTECTION_ERROR,
    BR_TRANSFER_REPEAT_START,
    BR_NEW_TRANSFER_START,
    BR_SEND_SUCCESS,
    BR_TEMP_UNAVAILABLE_PROV_SELECTED,
    BR_SEND_COUNTRY_TO_SELECTED,
    BR_REG_SEND_COUNTRY_TO_SELECTED,
    BR_REFERRAL_SCREEN_PRESS_ADD,
    BR_BANNER_EXTRA_BONUS_CLOSED,
    BR_BANNER_EXTRA_BONUS_PRESSED_T_AND_C,
    BR_BANNER_EXTRA_BONUS_PRESSED_ARROW,
    BR_SYSTEM_GA_DOWN_RETRY,
} as const;

export type BrazeEventKey = keyof typeof BRAZE_EVENTS;
export type BrazeEventValue = (typeof BRAZE_EVENTS)[BrazeEventKey];
